"use client";

import { OPEN_PREFS_EVENT } from "@/lib/consent";

export function CookiePrefsButton({ className }: { className?: string }) {
  return (
    <button type="button" onClick={() => window.dispatchEvent(new Event(OPEN_PREFS_EVENT))} className={className}>
      Cookie Preferences
    </button>
  );
}
